/** PURE_IMPORTS_START .._operators_startWith PURE_IMPORTS_END */
import { startWith as higherOrder } from '../operators/startWith';
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */
export function startWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i - 0] = arguments[_i];
    }
    return higherOrder.apply(void 0, array)(this);
}
//# sourceMappingURL=startWith.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/operator/startWith.js
// module id = 860
// module chunks = 0